import React__default from 'react';
import { Icon } from '@grandvisionhq/icons';

const IconLinkWithFallback = ({ url , labels , showLink =false , icon  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "link-item"
    }, showLink ? /*#__PURE__*/ React__default.createElement("a", {
        className: "link-item__link",
        href: url
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: icon !== null && icon !== void 0 ? icon : 'folded-page-with-text'
    }), /*#__PURE__*/ React__default.createElement("span", null, labels.linkCaption)) : /*#__PURE__*/ React__default.createElement("p", {
        className: "link-item__label"
    }, labels.fallback))
;

export { IconLinkWithFallback };
//# sourceMappingURL=IconLinkWithFallback.js.map
